var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotificationApproved(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-stream",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NOTIFICATIONS",
    transform: "translate(-14.000000, -1542.000000)",
    fill: "#7BCB45",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-9",
    transform: "translate(-1.000000, 1517.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(15.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "success"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,1.0658141e-14 C24.8221538,1.0658141e-14 32,7.17723077 32,16 C32,24.8227692 24.8221538,32 16,32 C7.17784615,32 -2.84217094e-14,24.8227692 -2.84217094e-14,16 C-2.84217094e-14,7.17723077 7.17784615,1.0658141e-14 16,1.0658141e-14 Z M16,30.7692308 C24.1433846,30.7692308 30.7692308,24.1433846 30.7692308,16 C30.7692308,7.85661538 24.1433846,1.23076923 16,1.23076923 C7.85661538,1.23076923 1.23076923,7.85661538 1.23076923,16 C1.23076923,24.1433846 7.85661538,30.7692308 16,30.7692308 Z M8.49723077,16.576 C8.37907692,16.4608 8.32,16.288 8.32,16.1728 C8.32,16.0576 8.37907692,15.8848 8.49723077,15.7696 L9.32430769,14.9632 C9.56061538,14.7328 9.91507692,14.7328 10.1513846,14.9632 L10.2104615,15.0208 L13.4596923,18.4192 C13.5778462,18.5344 13.7550769,18.5344 13.8732308,18.4192 L21.7895385,10.4128 L21.8486154,10.4128 C22.0849231,10.1824 22.4393846,10.1824 22.6756923,10.4128 L23.5027692,11.2192 C23.7390769,11.4496 23.7390769,11.7952 23.5027692,12.0256 L14.0504615,21.5872 C13.9323077,21.7024 13.8141538,21.76 13.6369231,21.76 C13.4596923,21.76 13.3415385,21.7024 13.2233846,21.5872 L8.61538462,16.7488 L8.49723077,16.576 Z",
    id: "icNo"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationApproved);
export default __webpack_public_path__ + "static/media/icNotificationApproved.19aa22713cb8d571f69eef36b405b7d5.svg";
export { ForwardRef as ReactComponent };